import React, { useContext } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Addordercontent from "../sections/Addorder/Addordercontent";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";

export const Addorder = (props) => {
  const ctx = useContext(AuthContext);

  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <Addordercontent />
      </main>
      <Quickbar />
    </div>
  );
};

export default Addorder;
